/* eslint-disable indent */
import {
  FilterPaginationDirectory,
  FilterPointsDirectory,
  LandingTypes,
  language,
  tridionLabels,
  isFlagActive
} from '@/infrastructure/Configuration'
import {
  contentService,
  destinationService,
  hotelService,
  loyaltyService,
  reservationsService,
  tripAdvisorService,
  myAccountService
} from '@/infrastructure/Factory'
import {
  getQueryParams,
  showModalChangesSavedSuccess,
  getPageLanguage
} from '@/infrastructure/Utils'
import { DateFactory, translate } from 'rhg-vue-common'
import CustomerProfile from '@/domain/CustomerProfile'
import helper from '../helpers/errorModal.js'

const trackDirectoryFilterEvent = eventData =>
  global.trackingService.track(
    global.trackingService.eventBuilder(global.trackingEvents.DIRECTORY_FILTER, eventData)
  )

const formatDirectoryFilterState = ({ selectedCountry, selectedState }) =>
  `${selectedState.name.toLowerCase()}-${selectedCountry.code.toLowerCase()}`

export default {
  async setCustomer({ commit, dispatch }, customer) {
    commit('setCurrentCustomer', customer)
  },

  async getLabels({ commit }) {
    commit('loading')
    const { labels } = await window.labelsService.getLabels()
    global.searchMapDestinationsLabels = { ...tridionLabels, ...labels }
    commit('labelsLoaded', true)
    commit('free')
  },

  async getBrands({ commit, dispatch }) {
    commit('loading')
    const newBrands = await destinationService.getBrands()
    commit('brands', newBrands)
    const { brands } = getQueryParams(window.location.search)
    if (brands) {
      for (const brand of newBrands) {
        if (brands.split(',').includes(brand.code)) {
          dispatch('toggleBrand', brand)
        }
      }
    }
    commit('free')
  },

  async getHotelTypes({ commit }) {
    commit('loading')
    const hotelTypes = await destinationService.getDestinationHotelTypes()
    commit('hotelTypes', hotelTypes)
    commit('free')
  },

  async getHotels({ commit, state, dispatch }) {
    const hotelLists = await Promise.all(
      state.brands.map(brand => destinationService.getHotelsByBrand(brand.code))
    )
    const hotels = hotelLists.reduce((acc, val) => acc.concat(val), [])
    dispatch('getCoBrandHotels', hotels)
    commit('addHotels', hotels)
  },

  async toggleBrand({ state, commit, getters, dispatch }, brand) {
    if (getters.isSelectedBrand(brand.code)) {
      commit('unSelectBrand', brand)
    } else {
      commit('selectBrand', brand)
      commit('setFilterTypeAndContent', { type: 'brand', value: brand })
    }
  },

  async toggleHotelType({ state, commit, getters, dispatch }, hotelType) {
    if (getters.isSelectedHotelType(hotelType.code)) {
      commit('unSelectHotelType', hotelType)
    } else {
      commit('selectHotelType', hotelType)
      commit('setFilterTypeAndContent', { type: 'hotelType', value: hotelType })
    }
  },

  formEdited({ commit }, formId) {
    commit('isFormEdited', true)
    commit('changeDiscarded', false)
    commit('currentModalId', formId)
  },
  changeDiscarded({ commit }) {
    commit('isFormEdited', false)
    commit('changeDiscarded', true)
  },
  formSaved({ commit }) {
    commit('isFormEdited', false)
  },
  resetFilters({ commit, dispatch }) {
    commit('selectedBrands', [])
    commit('selectedHotelTypes', [])
    commit('isOnlyRewards', false)

    commit('selectedOfferCity', null)
    commit('selectedOfferCountry', null)
    commit('checkInDate', null)
    commit('checkOutDate', null)

    commit('directorySelectedCountry', null)
    commit('directorySelectedCity', null)
    commit('directorySelectedState', null)
    commit('directoryStates', [])
    commit('directoryCities', [])
    commit('directoryFilterPoints', {
      min: FilterPointsDirectory.MIN,
      max: FilterPointsDirectory.MAX
    })
  },

  setSelectedBrands({ commit }, selectedBrands) {
    commit('selectedBrands', selectedBrands)
  },

  setSelectedHotelTypes({ commit }, selectedHotelTypes) {
    commit('selectedHotelTypes', selectedHotelTypes)
  },
  toggleFocus({ commit, state, dispatch }, selector) {
    const element = state.focus === selector ? '' : selector
    commit('focus', element)

    if (
      element === '' &&
      (selector === 'countrySelector' || selector === 'citySelector' || selector === '')
    ) {
      if (state.landingType === LandingTypes.OFFERS) dispatch('sendOffersFilterAnalyticsEvent')
    }
  },

  async getTripAdvisor({ commit, state }) {
    try {
      const hotelCodes = state.directory.hotels.map(hotel => hotel.code)
      const tripAdvisorRating = await tripAdvisorService.getTripAdvisorRating(hotelCodes)

      commit('tripAdvisorRating', tripAdvisorRating)
    } catch (e) {
      /* eslint-disable */
      console.error("The 'HotelDirectory.getTripAdvisor' action has failed: " + e)
    }
  },

  async getDirectoryHotels({ commit, state, dispatch }) {
    commit('loading')
    try {
      const params = {
        countryCode: state.directory.selectedCountry ? state.directory.selectedCountry.code : null,
        stateCode: state.directory.selectedState ? state.directory.selectedState.code : null,
        city: state.directory.selectedCity ? state.directory.selectedCity.name : null,
        minPoints: state.directory.points ? state.directory.points.min : null,
        maxPoints: state.directory.points ? state.directory.points.max : null,
        offset: state.directory.pagination ? state.directory.pagination.offset : null,
        limit: state.directory.pagination ? state.directory.pagination.limit : null
      }
      const loyaltyHotelsResponse = await loyaltyService.getHotelDirectory(params)
      if (loyaltyHotelsResponse.hotelDirectories.length === 0) {
        commit('free')
        return
      }
      const hotelCodes = loyaltyHotelsResponse.hotelDirectories
        .map(hotel => hotel.code)
        .filter(Boolean)
      const contentHotels = await destinationService.getHotels(hotelCodes)
      if (contentHotels.length === 0) {
        commit('free')
        return
      }
      const directoryMap = loyaltyHotelsResponse.hotelDirectories.reduce(function(acc, hotel) {
        acc[hotel.code] = hotel
        return acc
      }, {})
      const hotels = contentHotels.map(function(hotel) {
        return Object.assign({}, hotel, directoryMap[hotel.code])
      })
      dispatch('getCoBrandHotels', hotels)
      commit('directoryHotels', [...state.directory.hotels, ...hotels])
      commit('directoryPagination', {
        total: loyaltyHotelsResponse.paging.total
      })
      dispatch('getTripAdvisor')

      commit('free')
    } catch (err) {
      commit('free')
    }
  },
  async getCoBrandHotels({ commit }, hotels) {
    const coBrandHotels = hotels
      .filter(hotel => hotel.coBrand)
      .reduce((acc, item) => {
        if (!acc.includes(item.coBrand)) {
          acc.push(item.coBrand)
        }
        return acc
      }, [])

    if (coBrandHotels.length > 0) {
      const cobrandImages = await hotelService.getCoBrandsImage(coBrandHotels)
      commit('setCoBrandsImages', cobrandImages)
    }
  },
  async getDirectoryCountries({ commit }) {
    const countries = await loyaltyService.getCountries()
    commit('directoryCountries', countries)
  },

  async getDirectoryCitiesOrStates({ commit, dispatch }, countryCode) {
    const states = await loyaltyService.getStatesByCountry(countryCode)
    if (states && states.length > 0) {
      commit('directoryStates', states)
    } else {
      dispatch('getDirectoryCities', { countryCode })
    }
  },

  async getDirectoryCities({ commit }, location) {
    const cities = await loyaltyService.getCitiesByCountryOrState(location)

    commit('directoryCities', cities)
  },

  async getCustomerProfile({ commit }) {
    try {
      commit('loadingCustomer', true)
      commit('customerProfile', CustomerProfile.fromJSON({}))
      const customerProfile = await loyaltyService.getProfile()
      commit('customerProfile', customerProfile)
      commit('loadingCustomer', false)
    } catch (error) {
      commit('loadingCustomer', false)
      throw error
    }
  },

  async saveCustomer({ commit, dispatch }, customer) {
    try {
      commit('loadingCustomer', true)
      const updateProfile = await loyaltyService.updateProfile(customer)
      if (updateProfile && updateProfile.mfaRequired) {
        return await dispatch('handleShowModalVerifySmsCode', customer)
      } else {
        await dispatch('getCustomerProfile')
      }
    } catch (error) {
      commit('loadingCustomer', false)
      throw error
    }
  },
  async enableTwoStepValidator({ commit, dispatch },  customer) {
    try {
      commit('loadingCustomer', true)
      const telephone = {
          ...customer.customerProfile.telephone,
          number: customer.customerProfile.telephone.number.replace(/\s+/g, '')
      }
      const updateProfile = await loyaltyService.requestActivateMfa({ telephone, cToken: customer.cToken })
      if (updateProfile && updateProfile.mfaRequired) {
        return await dispatch('handleShowModalVerifySmsCode', customer)
      } else {
        await dispatch('getCustomerProfile')
      }
    } catch (error) {
      commit('loadingCustomer', false)
      throw error
    }
  },

  async handleShowModalVerifySmsCode({ dispatch, state, commit }, customer) {
    function getProfile(onGetProfile) {
      return async () => {
        try {
          await dispatch('getCustomerProfile')
          typeof onGetProfile === 'function' && onGetProfile()
        } catch (error) {
          const err = Object.assign({}, error.response.data, { status: error.response.status })
          global.ApiHandlers.handleErrorsMessage(err)
          throw error
        }
      }
    }

    async function onClose() {
      await dispatch('getCustomerProfile')
      global.$('#modal-verify-sms-code').off('hidden.bs.modal', onClose)
    }

    global.$('#modal-verify-sms-code').on('hidden.bs.modal', onClose)

    const customerProfile = await loyaltyService.getProfile()

    const rrNumber = state.customerProfile.rewardsNumber
    const email = state.customerProfile.email
    const verificationPhone = customerProfile.telephone

    if (customer.customerProfile.multifactor) {
      const showConfirmationModal = () => {
        global.ConfirmationModals.showTwofactorActivatedModal()
      }
      setTimeout(() => {
        global.ModalVerifySmsCode.showValidateUpdateModal(
          rrNumber,
          email,
          verificationPhone,
          getProfile(showConfirmationModal)
        )
      }, 1000)
      return { showMfaSuccesModal: true }
    } else if (customer.customerProfile.telephone) {
      const showConfirmationModal = () => {
        global.ConfirmationModals.showTwofactorUpdatedModal()
      }
      global.ModalVerifySmsCode.showValidateUpdateModal(
        rrNumber,
        email,
        verificationPhone,
        getProfile(showConfirmationModal)
      )
      return { showMfaSuccesModal: true }
    } else {
      global.ModalVerifySmsCode.showValidateUpdateModal(
        rrNumber,
        email,
        verificationPhone,
        getProfile(showModalChangesSavedSuccess)
      )
      return { showMfaSuccesModal: true }
    }
  },

  async getPreferences({ commit }) {
    commit('loadingPreferences', true)
    commit('preferences', {})
    const preferences = await loyaltyService.getPreferences()
    commit('preferences', preferences)
    commit('loadingPreferences', false)
  },

  async savePreferences({ commit }, preferences) {
    try {
      commit('loadingPreferences', true)
      commit('preferences', {})
      await loyaltyService.savePreferences(preferences)
      const updatedPreferences = await loyaltyService.getPreferences()
      commit('preferences', updatedPreferences)
      commit('loadingPreferences', false)
    } catch (error) {
      commit('loadingPreferences', false)
    }
  },

  async updateCustomerEmail({ commit }, email) {
    await loyaltyService.updateEmail(email)
    const updatedCustomer = await loyaltyService.getProfile()
    commit('customerProfile', updatedCustomer)
  },
  async deleteTravelDocument({ commit }) {
    const customerProfile = {
      document: {
        type: '',
        number: '',
        issueDate: '',
        expirationDate: '',
        nationality: '',
        consentShow: false
      }
    }
    try {
      commit('loadingCustomer', true)
      await loyaltyService.updateProfile({ customerProfile })
      commit('customerProfile', CustomerProfile.fromJSON({}))
      const updatedCustomer = await loyaltyService.getProfile()
      commit('customerProfile', updatedCustomer)
      commit('loadingCustomer', false)
    } catch (error) {
      commit('loadingCustomer', false)
      throw error
    }
  },

  setSelectedDirectoryCountry({ commit, state, dispatch }, selectedCountry) {
    commit('directorySelectedCity', null)
    commit('directorySelectedState', null)
    commit('directoryStates', [])
    commit('directoryCities', [])
    commit('directorySelectedCountry', selectedCountry)
    dispatch('resetDirectoryPagination')
    dispatch('resetDirectoryHotels')
    trackDirectoryFilterEvent({
      directoryFilterCountry: selectedCountry.code
    })
  },

  setSelectedDirectoryState({ commit, state, dispatch }, selectedCountryState) {
    commit('directorySelectedCity', null)
    commit('directoryCities', [])
    commit('directorySelectedState', selectedCountryState.selectedState)
    dispatch('resetDirectoryPagination')
    dispatch('resetDirectoryHotels')

    trackDirectoryFilterEvent({
      directoryFilterCountry: selectedCountryState.selectedCountry.code,
      directoryFilterState: formatDirectoryFilterState(selectedCountryState)
    })
  },

  setSelectedDirectoryCity({ commit, state, dispatch }, selectedCountryStateCity) {
    commit('directorySelectedCity', selectedCountryStateCity.selectedCity)

    dispatch('resetDirectoryPagination')
    dispatch('resetDirectoryHotels')

    trackDirectoryFilterEvent({
      directoryFilterCountry: selectedCountryStateCity.selectedCountry.code,
      ...(selectedCountryStateCity.selectedState
        ? { directoryFilterState: formatDirectoryFilterState(selectedCountryStateCity) }
        : {}),
      directoryFilterCity: selectedCountryStateCity.selectedCity.name
    })
  },

  setDirectoryFilterPoints({ commit, dispatch }, range) {
    commit('loading')
    commit('directoryFilterPoints', {
      min: range.min,
      max: range.max
    })

    trackDirectoryFilterEvent({})

    dispatch('resetDirectoryPagination')
    dispatch('resetDirectoryHotels')
    dispatch('getDirectoryHotels')
    commit('free')
  },

  loadMoreDirectoryHotels({ commit, state, dispatch }) {
    const offsetNumHotels = state.directory.pagination.offset + state.directory.pagination.limit
    commit('directoryPagination', {
      offset: offsetNumHotels
    })
    dispatch('getDirectoryHotels')
  },

  resetDirectoryPagination({ commit }) {
    commit('directoryPagination', {
      offset: FilterPaginationDirectory.OFFSET,
      limit: FilterPaginationDirectory.LIMIT,
      total: null
    })
  },

  resetDirectoryHotels({ commit }) {
    commit('directoryHotels', [])
  },

  async sendAnalyticsView({ state, getters }) {
    const analyticsVariables = {}
    const { originPropertyId } = getters.getUrlParams()

    analyticsVariables.isQREnrolment = originPropertyId != null
    try {
      if (LandingTypes.RESERVATIONS !== 'reservations') {
        const data = await loyaltyService.getPromocodes()
        analyticsVariables.user_ecerts_available = data.vouchers.map(e => e.name).join(' | ')
      }
    } catch {
      analyticsVariables.user_ecerts_available = ''
    } finally {
      analyticsVariables.isRefereeEnrolment = window.location.search.includes('refererCode')
      global.trackingService.appendViewData(analyticsVariables)
      global.trackingService.triggerAnalyticsEvent()
    }

    global.trackingService.appendViewData(analyticsVariables)
    global.trackingService.triggerAnalyticsEvent()
  },

  setFilters({ commit, getters, dispatch }) {
    const {
      rewards,
      brands: brandCodes,
      country: countryCode,
      city: cityCode,
      checkInDate,
      checkOutDate,
      hotelTypes: hotelTypeCodes
    } = getters.getUrlParams()
    if (rewards === 'true') commit('isOnlyRewards', true)
    if (brandCodes) {
      const splitBrandCodes = brandCodes.split(',')
      splitBrandCodes.forEach(brandCode => {
        const requestedBrand = getters.brands.find(brand => brand.code === brandCode)
        if (requestedBrand) commit('selectBrand', requestedBrand)
      })
    }
    if (countryCode) {
      const requestedCountry = getters.offerCountries.find(
        country => country.code.toLowerCase() === countryCode.toLowerCase()
      )
      if (requestedCountry) commit('selectedOfferCountry', requestedCountry)
    }
    if (cityCode) {
      const splitCountryCode = cityCode.split('-')
      const countryCode =
        splitCountryCode.length > 2
          ? splitCountryCode[splitCountryCode.length - 2] +
            '-' +
            splitCountryCode[splitCountryCode.length - 1]
          : splitCountryCode[splitCountryCode.length - 1]
      const requestedCountry = getters.offerCountries.find(
        country => country.code.toLowerCase() === countryCode.toLowerCase()
      )
      if (requestedCountry) {
        commit('selectedOfferCountry', requestedCountry)
        const requestedCity = requestedCountry.cities.find(
          city => city.code.toLowerCase() === cityCode.toLowerCase()
        )
        if (requestedCity) commit('selectedOfferCity', requestedCity)
      }
    }
    if (checkInDate) {
      commit('checkInDate', DateFactory.dateFromPattern(checkInDate))
    }
    if (checkOutDate) {
      commit('checkOutDate', DateFactory.dateFromPattern(checkOutDate))
    }
    if (hotelTypeCodes) {
      const splitHotelTypeCodes = hotelTypeCodes.split(',')
      splitHotelTypeCodes.forEach(hotelTypeCode => {
        const requestedHotelType = getters.hotelTypes.find(
          hotelType => hotelType.code === hotelTypeCode
        )
        if (requestedHotelType) commit('selectHotelType', requestedHotelType)
      })
    }
  },

  async fetchPrice({ commit }, hotelCode) {
    commit('loadingPrice', true)
    const price = await hotelService.getFromPrice(hotelCode)

    commit('fromPrice', price)
    commit('loadingPrice', false)
  },

  setCurrentFavHotel({ commit }, currentFavHotel) {
    commit('currentFavHotel', currentFavHotel)
  },

  async trackFavouriteHotelEvent({ state }, eventName) {
    const eventData = {
      favoriteHotel: `${state.currentFavHotel.code}-${state.currentFavHotel.name}`
    }
    global.trackingService.track(
      global.trackingService.eventBuilder(global.trackingEvents[eventName], eventData)
    )
  },
  async trackCrowdEvent({ state }, payload) {
    const eventData = {
      userCrowdApplicable: `${payload.value || ''}`
    }
    global.trackingService.track(
      global.trackingService.eventBuilder(global.trackingEvents[payload.eventName], eventData)
    )
  },
  async getCobrandImages({ state, commit }, hotel) {
    const hotels = hotel
      .filter(item => {
        return item.hotel.coBrand
      })
      .reduce((acc, item) => {
        if (!acc.includes(item.hotel.coBrand)) {
          acc.push(item.hotel.coBrand)
        }
        return acc
      }, [])
    if (hotels.length > 0) {
      const cobrandImages = await hotelService.getCoBrandsImage(hotels)
      commit('setCoBrandsImages', cobrandImages)
    }
  },

  async trackEvent({ state }, { eventName, eventData }) {
    global.trackingService.track(
      eventData
        ? global.trackingService.eventBuilder(global.trackingEvents[eventName], eventData)
        : global.trackingEvents[eventName]
    )
  },

  trackErrorEventEnrollment({ state, dispatch }, { error, isParsed, type }) {
    let parseError
    try {
      parseError = isParsed
        ? error
        : Object.entries(error).reduce((acc, [key, value]) => {
            const separator = acc ? ' | ' : ''
            const hasValue = value[0]
            const unnamedField = key.indexOf('_vee_') > -1
            const passwordField = key.indexOf('password') > -1
            const appendError = (condition, name, error) =>
              hasValue && !condition ? acc.concat(`${separator}${name} : ${error}`) : acc

            if (key === 'travelAgent' || key === 'meetingPlanner') {
              const selectAtLeastOne = 'You should select at least one role'
              const hasAlreadyCheckedSelector = acc.indexOf('memberTypeSelector') > -1
              return appendError(hasAlreadyCheckedSelector, 'memberTypeSelector', selectAtLeastOne)
            } else if (passwordField) {
              const hasAlreadyPassword = acc.indexOf('password') > -1
              return appendError(hasAlreadyPassword, 'password', hasValue)
            } else {
              return appendError(unnamedField, key, hasValue)
            }
          }, '')
    } catch {
      parseError = error
    }

    dispatch('trackEvent', {
      eventName: 'FORM_ERROR',
      eventData: {
        formErrorValue: parseError,
        formName: type
      }
    })
  },

  sendStep2Analytics({ dispatch }) {
    const analyticsVariables = {
      pageName: 'radisson-rewards>join-b2b>step2'
    }
    dispatch('sendAnalyticsPage', analyticsVariables)
  },

  setDataGatheringPageName({ dispatch }, data) {
    const analyticsVariables = {
      pageName: `my-account>data-gathering-${data.customerType}>question-${data.currentQuestion +
        1}`
    }
    dispatch('sendAnalyticsPage', analyticsVariables)
  },

  setMyAccountPageName({ dispatch }) {
    const analyticsVariables = {
      pageName: 'radisson-rewards>secure>my-account'
    }
    dispatch('sendAnalyticsPage', analyticsVariables)
  },

  sendDataGatheringAnalytics({ dispatch }, data) {
    const analyticsVariables = {
      pageName: `my-account>data-gathering-${
        data.customerType
      }>question-answered-${data.currentQuestion + 1}`
    }
    dispatch('sendAnalyticsPage', analyticsVariables)
  },

  sendAnalyticsPage({ state }, analyticsVariables) {
    global.trackingService.buildViewData(analyticsVariables)
    global.trackingService.triggerAnalyticsEvent()
    try {
      global.utag.view(global.utag_data, null, null)
    } catch (e) {
      /* eslint-disable */
      console.error(e)
    }
  },

  async getTransliteratableLanguages({ commit }) {
    const languages = await contentService.transliteratableLanguages()
    const showTransliteratedField = languages.some(lang => lang.code.split('-')[0] === language)
    commit('showTransliteratedField', showTransliteratedField)
    commit('updateTransliterableLanguagesLoaded', true)
  },

  async fetchReservations(
    { state, commit, dispatch },
    { memberType, groupType, page, limit, hasPagination = true, firstName, lastName }
  ) {
    commit('fetchingReservations')
    const { count, reservations } = await reservationsService.getNewReservations({
      memberType: memberType,
      groupType,
      page,
      limit,
      firstName,
      lastName
    })
    await dispatch('fetchReservationsCiCoInfo', {
      count,
      reservations,
      page,
      groupType,
      hasPagination
    })
  },

  async fetchInviteMember({ commit }) {
    try {
      const inviteMember = await contentService.getInviteMember()
      commit('setInviteMember', inviteMember)
    } catch (e) {
      /* eslint-disable */
      console.log(e)
    }
  },

  async fetchReservationsCiCoInfo({ state, dispatch, commit }, data) {
    const { page, groupType, hasPagination } = data
    const reservationsWithInfo = await reservationsService.getBookingCheckInfo(
      data.reservations,
      data.count,
      data.groupType
    )
    const { reservations, count } = reservationsWithInfo
    commit('fetchedReservations', { count, reservations, page, groupType, hasPagination })

    if (
      state.currentView === LandingTypes.RESERVATIONS &&
      groupType !== 'past' &&
      groupType !== 'cancelled'
    ) {
      dispatch('fetchReservationsWithExploreHotel')
    }
  },

  async fetchB2BBusinessReservations({ commit, dispatch }, { memberType, groupType, page, limit }) {
    commit('fetchingReservations')
    const { count, reservations } = await reservationsService.getNewReservations({
      memberType: memberType,
      groupType,
      page,
      limit
    })
    await dispatch('fetchB2BBusinessReservationsCiCoInfo', {
      count,
      reservations,
      page,
      groupType,
      memberType
    })
  },

  async fetchB2BBusinessReservationsCiCoInfo({ commit }, data) {
    const { page, groupType, memberType } = data
    const reservationsWithInfo = await reservationsService.getBookingCheckInfo(
      data.reservations,
      data.count,
      data.groupType
    )
    const { reservations, count } = reservationsWithInfo

    commit('fetchedB2BBusinessReservations', { count, reservations, page, groupType, memberType })
  },

  async fetchB2BPersonalReservations({ commit, dispatch }, { memberType, groupType, page, limit }) {
    commit('fetchingReservations')
    const { count, reservations } = await reservationsService.getNewReservations({
      memberType: memberType,
      groupType,
      page,
      limit
    })
    await dispatch('fetchB2BPersonalReservationsCicoInfo', {
      count,
      reservations,
      page,
      groupType,
      memberType
    })
  },

  async fetchB2BPersonalReservationsCicoInfo({ commit }, data) {
    const { page, groupType, memberType } = data
    const reservationsWithInfo = await reservationsService.getBookingCheckInfo(
      data.reservations,
      data.count,
      data.groupType
    )
    const { reservations, count } = reservationsWithInfo

    commit('fetchedB2BPersonalReservations', { count, reservations, page, groupType, memberType })
  },

  async fetchReservationsWithExploreHotel({ state, commit }) {
    const newReservations = state.reservations.reservations.filter(
      el =>
        !state.reservationsWithExploreHotel.find(val => {
          return el.bookingId === val.bookingId
        })
    )

    const reservationsWithExploreHotel = await Promise.all(
      newReservations.map(async reservation => {
        const { myReservationsExploreModules } = await reservationsService.getExploreHotel(
          reservation.hotelCode
        )
        return { ...reservation, myReservationsExploreModules }
      })
    )
    commit('setReservationsWithExploreHotel', reservationsWithExploreHotel)
  },

  async getNoReservations({ commit }, agent) {
    const noReservationsData = await reservationsService.getNoReservations(agent)
    commit('setNoReservationsData', noReservationsData)
  },

  async setCurrentView({ commit }, currentView) {
    commit('setCurrentView', currentView)
  },

  setTransferedPoints({ state }, points) {
    const analyticsVariables = {
      pointsTransfered: points
    }
    global.trackingService.buildViewData(analyticsVariables)
    global.trackingService.triggerAnalyticsEvent()
    try {
      global.utag.view(global.utag_data, null, null)
    } catch (e) {
      /* eslint-disable */
      console.error(e)
    }
  },

  async updateCustomerProfileCompletition({ commit }, customer) {
    commit('setCurrentCustomerProfileCompletition', customer)
  },

  async sendInvoice({ commit, dispatch }, invoiceIds) {
    try {
      commit('loadingInvoice', true)
      const payLoad = {
        invoicesIds: invoiceIds
      }
      await reservationsService.sendInvoice(payLoad)
      commit('loadingInvoice', false)
      dispatch('handleInvoiceSuccess')
    } catch (e) {
      dispatch('handleInvoiceError', e)
      commit('loadingInvoice', false)
    }
  },

  handleInvoiceSuccess({ _ }) {
    global.$('#modal-invoice').modal('show')
  },

  handleInvoiceError({ _ }, error) {
    global.ModalMsg.show('#modal-error')
  },

  async fetchTransactions(
    { commit },
    { type, filter, page, limit, hasPagination, dateFrom, dateTo, filterApplied, accountType }
  ) {
    commit('fetchingTransactions')
    const { count, transactions } = await loyaltyService.getTransactions({
      type,
      filter,
      page,
      limit,
      dateFrom,
      dateTo,
      accountType
    })

    await commit('fetchedTransactions', {
      count,
      transactions,
      page,
      hasPagination,
      filterApplied
    })
  },

  async updateTransactionTypeFilter({ state, commit }, data) {
    commit('setTransactionsTypeFilter', data)
  },

  async updateTransactionCategoryFilter({ state, commit }, data) {
    commit('setTransactionsCategoryFilter', data)
  },

  async updateTransactionDateFilter({ state, commit }, data) {
    if (data?.start === null) {
      commit('setTransactionsDateFilter', { dateFrom: '', dateTo: '' })
      return
    }
    const dateFrom = DateFactory.formatDate(data.start)
    const dateTo = DateFactory.formatDate(data.end)
    commit('setTransactionsDateFilter', { dateFrom, dateTo })
  },

  async resetTransactionsInfo({ commit }) {
    commit('resetTransactionsState')
  },

  async resetTransactionsFilter({ commit }) {
    commit('resetTransactionsFilters')
  },
  async resetTransactionsTypeFilters({ commit }) {
    commit('resetTransactionsTypeFilters')
  },
  async resetTransactionsCategoryFilters({ commit }) {
    commit('resetTransactionsCategoryFilters')
  },
  async resetTransactionsDateFilters({ commit }) {
    commit('resetTransactionsDateFilters')
  },

  async sendSubscriptionModuleRequest({ state, commit }) {
    try {
      commit('loadingNewsletter', true)
      const paramsPreferences = {
        marketingEmailsConsent: true
      }
      await loyaltyService.savePreferences(paramsPreferences)
      commit('loadingNewsletter', false)
      global.$('#subscription-modal').modal('hide')
      global.$('#subscription-confirmed-modal').modal('show')
      global.trackingService.track(global.trackingEvents.SUCCESSFUL_OPT_IN_ACTIVATION_ACCOUNT)
    } catch (e) {
      commit('loadingNewsletter', false)
      global.$('#subscription-modal').modal('hide')
      global.ModalMsg.show('#modal-error')
    }
  },

  async subscribeNotificationClosed({ commit, dispatch }) {
    try {
      commit('loadingNewsletter', true)
      const customerProfile = { subscriptionModuleClose: true }
      await loyaltyService.updateProfile({ customerProfile })
      commit('loadingNewsletter', false)
      await dispatch('getCustomerProfile')
    } catch (error) {
      global.ModalMsg.show('#modal-error')
      commit('loadingNewsletter', false)
      throw error
    }
  },

  async claimPoints({ commit, dispatch }, bookingId) {
    try {
      commit('loadingClaimPoints', true)
      await loyaltyService.claimPoints(bookingId)
      dispatch('trackEvent', {
        eventName: 'FORM_SUBMISSION',
        eventData: {
          formName: 'claim_missing_points'
        }
      })
      global.$('#claim-point-modal-success').modal('show')
      commit('loadingClaimPoints', false)
    } catch (error) {
      dispatch('trackEvent', {
        eventName: 'FORM_ERROR',
        eventData: {
          formName: 'claim_missing_points'
        }
      })
      if (isFlagActive('private.claim.missing.points.error')) {
        const { errorFactoryModal } = helper()
        errorFactoryModal(error?.response?.data)
      } else {
        global.ModalMsg.show(
          '#modal-error',
          {
            title: translate('paClaimPointsFailedTitle'),
            subtitle: translate('paClaimPointsFailedDescription')
          },
          null,
          null,
          {
            url: `/${getPageLanguage().toLowerCase()}${translate(
              'paClaimPointsFailedCTADeepLink'
            )}`,
            label: translate('paClaimPointsFailedCTA'),
            show: true
          }
        )
      }
      commit('loadingClaimPoints', false)
    }
  },
  async removeTrustedDevices({ commit, dispatch }) {
    try {
      commit('loadingCustomer', true)
      await loyaltyService.removeTrustedDevices()
    } finally {
      commit('loadingCustomer', false)
    }
  },
  async getAppleTreeBannerInfo ({ commit }, agent) {
    try {
      const bannerInfo = await myAccountService.getAppleTreeB2bBanner(agent)
      commit('setAppleTreeBannerInfo', bannerInfo)
    } catch (e) {
      commit('setAppleTreeBannerInfo', null)
      throw e
    }
  }
}
